import React from 'react';
import { TextField } from '@mui/material';
import { get } from 'lodash';
import { Controller } from 'react-hook-form';

const CustomTextInput = ({
  control,
  name,
  label,
  errors,
  helperText,
  type = 'text',
  readOnly,
  disabled,
  endAdornment,
  ...rest
}) => {
  const errorMessage = get(errors, name, {})?.message;
  const combinedHelperText = [helperText, errorMessage].filter(Boolean).join(' * ');

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          type={type}
          id={name}
          label={label}
          variant="outlined"
          fullWidth
          {...field}
          error={!!errorMessage}
          helperText={combinedHelperText}
          disabled={disabled}
          InputProps={{
            endAdornment,
            readOnly,
          }}
          {...rest}
        />
      )}
    />
  );
};

export default CustomTextInput;
